export const BaseLocatization = {
  //SidePanel
  AdminPanel: 'Admin Panel',
  greetings: 'Hello, ',
  Home: 'Home',

  //Distributors + User
  Distributors: 'Distributors',
  AddDistributor: 'Add Distributor',
  AutoSMS: 'Auto SMS',
  DigiCard: 'Digi Card',
  AddProfiles: 'Add profiles',
  Username: 'Display Name',
  PlanName: 'Plan Name',
  Amount: 'Amount',
  PaymenttId: 'Payment tracking Id.',
  ActivationStatusQuestion: 'Are you sure you want to ',

  Users: 'Users',
  AddUser: 'Add User',
  numberOfMonths: 'Number of Months',

  //Actions
  Deactivate: 'Deactivate',
  Activate: 'Activate',
  Cancel: 'Cancel',
};
